// API URL FOR DEVELOPMENT MODE
const dev = {
  API_ENDPOINT_URL: 'https://api-dev.fortunamarkets.org',
  MARKET_ANALYSIS_ENDPOINT_URL: 'https://test-api.fortuna.investments',
  MARKET_KEY: 'sdfasdflkoefdofr'
};

// API URL FOR PRODUCTION MODE
const prod = {
  API_ENDPOINT_URL: 'https://api-dev.fortunamarkets.org',
  MARKET_ANALYSIS_ENDPOINT_URL: 'https://main-api.fortuna.investments',
  MARKET_KEY: 'bRN85Fxm76uG62kx'
};

// API URL FOR TEST MODE
const test = {
  API_ENDPOINT_URL: 'https://api-dev.fortunamarkets.org/',
  MARKET_ANALYSIS_ENDPOINT_URL: 'https://main-api.fortuna.investments',
  MARKET_KEY: 'bRN85Fxm76uG62kx'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()